(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class CustomerReviews {
    constructor(el) {
      this.el = el;
      this.slider = el.querySelector('[data-cr-slider]');
      this.track = el.querySelector('[data-cr-track]');
      if (!this.track) return;

      this.items = Array.from(this.track.querySelectorAll('[data-cr-item]'));
      this.prevBtn = el.querySelector('[data-cr-prev]');
      this.nextBtn = el.querySelector('[data-cr-next]');
      this.dotsWrap = el.querySelector('[data-cr-dots]');

      this.total = this.items.length;
      if (this.total === 0) return;

      this.current = 0;
      this.autoplay = el.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;
      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;

      this.itemsPerView = this.getItemsPerView();
      this.maxIndex = Math.max(0, this.total - this.itemsPerView);

      this.buildDots();
      this.updateSlider();
      this.bindEvents();

      if (this.autoplay && this.total > this.itemsPerView) {
        this.startAutoplay();
      }
    }

    getItemsPerView() {
      const styles = getComputedStyle(this.el);
      const width = window.innerWidth;
      if (width <= 749) {
        return parseInt(styles.getPropertyValue('--cr-items-mobile'), 10) || 1;
      } else if (width <= 1024) {
        return parseInt(styles.getPropertyValue('--cr-items-tablet'), 10) || 2;
      }
      return parseInt(styles.getPropertyValue('--cr-items-desktop'), 10) || 3;
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      const dotCount = this.maxIndex + 1;
      if (dotCount <= 1) {
        this.dotsWrap.style.display = 'none';
        return;
      }
      this.dotsWrap.style.display = '';
      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cr-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          this.goTo(i);
          this.restartAutoplay();
        });
        this.dotsWrap.appendChild(dot);
      }
      this.dots = Array.from(this.dotsWrap.querySelectorAll('.cr-dot'));
    }

    updateSlider() {
      const item = this.items[0];
      if (!item) return;
      const itemWidth = item.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.current * (itemWidth + gap));
      this.track.style.transform = `translateX(${offset}px)`;

      if (this.dots) {
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
      }

      if (this.prevBtn) this.prevBtn.disabled = this.current === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.current >= this.maxIndex;
    }

    goTo(index) {
      this.current = Math.max(0, Math.min(index, this.maxIndex));
      this.updateSlider();
    }

    next() {
      if (this.current >= this.maxIndex) this.goTo(0);
      else this.goTo(this.current + 1);
    }

    prev() {
      if (this.current <= 0) this.goTo(this.maxIndex);
      else this.goTo(this.current - 1);
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => { this.prev(); this.restartAutoplay(); });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => { this.next(); this.restartAutoplay(); });
      }

      this.slider.addEventListener('touchstart', (e) => this.onDragStart(e.touches[0].clientX), { passive: true });
      this.slider.addEventListener('touchmove',  (e) => this.onDragMove(e.touches[0].clientX),  { passive: true });
      this.slider.addEventListener('touchend',   () => this.onDragEnd());

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const newItemsPerView = this.getItemsPerView();
          if (newItemsPerView !== this.itemsPerView) {
            this.itemsPerView = newItemsPerView;
            this.maxIndex = Math.max(0, this.total - this.itemsPerView);
            this.current = Math.min(this.current, this.maxIndex);
            this.buildDots();
          }
          this.updateSlider();
        }, 150);
      });

      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay();
        else if (this.autoplay) this.startAutoplay();
      });
    }

    onDragStart(x) {
      this.isDragging = true;
      this.startX = x;
      this.currentX = x;
      this.stopAutoplay();
    }

    onDragMove(x) {
      if (!this.isDragging) return;
      this.currentX = x;
    }

    onDragEnd() {
      if (!this.isDragging) return;
      const diff = this.startX - this.currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.next();
        else this.prev();
      }
      this.isDragging = false;
      if (this.autoplay) this.startAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      if (this.total <= this.itemsPerView) return;
      this.timer = setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    restartAutoplay() {
      if (this.autoplay) { this.stopAutoplay(); this.startAutoplay(); }
    }
  }

  document.querySelectorAll('.cr-section').forEach((el) => new CustomerReviews(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('[data-hero-track]');
      if (!this.track) return;

      this.slides = Array.from(this.track.querySelectorAll('.hero-slider__slide'));
      this.dots = Array.from(el.querySelectorAll('[data-hero-dots] .hero-slider__dot'));
      this.total = this.slides.length;
      if (this.total <= 1) return;

      this.current = 0;
      this.autoplay = el.dataset.autoplay === 'true';
      this.speed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;
      this.isHovered = false;

      this.bindEvents();
      if (this.autoplay) this.startAutoplay();
    }

    bindEvents() {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.slideTo, 10);
          this.goTo(index);
          this.restartAutoplay();
        });
      });

      this.el.addEventListener('mouseenter', () => {
        this.isHovered = true;
        this.stopAutoplay();
      });
      this.el.addEventListener('mouseleave', () => {
        this.isHovered = false;
        if (this.autoplay) this.startAutoplay();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay();
        else if (this.autoplay && !this.isHovered) this.startAutoplay();
      });
    }

    goTo(index) {
      if (index === this.current) return;
      const prev = this.current;

      this.slides[prev].classList.remove('is-active');
      this.slides[prev].classList.add('is-prev');
      this.slides[index].classList.add('is-active');
      this.slides[index].classList.remove('is-prev');

      setTimeout(() => {
        this.slides.forEach((s, i) => {
          if (i !== index) s.classList.remove('is-prev');
        });
      }, 700);

      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      this.current = index;
    }

    next() {
      const nextIndex = (this.current + 1) % this.total;
      this.goTo(nextIndex);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.next(), this.speed);
    }

    stopAutoplay() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    restartAutoplay() {
      if (this.autoplay) { this.stopAutoplay(); this.startAutoplay(); }
    }
  }

  document.querySelectorAll('.hero-slider').forEach((el) => new HeroSlider(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loved-by-thousands"] && !Shopify.designMode) return;
  try {
    
  class LBTSlider {
    constructor(el) {
      this.el = el;
      this.sliderWrap = el.querySelector('[data-lbt-slider]');
      this.track = el.querySelector('[data-lbt-track]');
      this.dotsWrap = el.querySelector('[data-lbt-dots]');
      if (!this.track) return;

      this.items = Array.from(this.track.querySelectorAll('[data-lbt-item]'));
      this.total = this.items.length;
      if (this.total === 0) return;

      this.current = 0;
      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;

      this.updateOnResize();
      window.addEventListener('resize', this.debounce(() => this.updateOnResize(), 150));
      this.bindTouch();
    }

    debounce(fn, delay) {
      let timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, delay);
      };
    }

    isMobile() {
      return window.innerWidth <= 749;
    }

    updateOnResize() {
      if (this.isMobile()) {
        this.setupSlider();
      } else {
        this.disableSlider();
      }
    }

    getItemsPerView() {
      const styles = getComputedStyle(this.el);
      return parseInt(styles.getPropertyValue('--lbt-items-mobile'), 10) || 1;
    }

    setupSlider() {
      this.itemsPerView = this.getItemsPerView();
      this.maxIndex = Math.max(0, this.total - this.itemsPerView);
      this.current = Math.min(this.current, this.maxIndex);
      this.buildDots();
      this.updateSlider();
    }

    disableSlider() {
      if (this.track) {
        this.track.style.transform = '';
      }
      if (this.dotsWrap) {
        this.dotsWrap.innerHTML = '';
      }
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      const dotCount = this.maxIndex + 1;
      if (dotCount <= 1) {
        this.dotsWrap.style.display = 'none';
        return;
      }
      this.dotsWrap.style.display = '';
      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lbt-dot' + (i === this.current ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsWrap.appendChild(dot);
      }
      this.dots = Array.from(this.dotsWrap.querySelectorAll('.lbt-dot'));
    }

    updateSlider() {
      if (!this.isMobile()) return;
      const item = this.items[0];
      if (!item) return;
      const itemWidth = item.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.current * (itemWidth + gap));
      this.track.style.transform = `translateX(${offset}px)`;

      if (this.dots) {
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
      }
    }

    goTo(index) {
      this.current = Math.max(0, Math.min(index, this.maxIndex));
      this.updateSlider();
    }

    next() {
      if (this.current >= this.maxIndex) this.goTo(0);
      else this.goTo(this.current + 1);
    }

    prev() {
      if (this.current <= 0) this.goTo(this.maxIndex);
      else this.goTo(this.current - 1);
    }

    bindTouch() {
      if (!this.sliderWrap) return;

      this.sliderWrap.addEventListener('touchstart', (e) => {
        if (!this.isMobile()) return;
        this.isDragging = true;
        this.startX = e.touches[0].clientX;
        this.currentX = this.startX;
      }, { passive: true });

      this.sliderWrap.addEventListener('touchmove', (e) => {
        if (!this.isDragging || !this.isMobile()) return;
        this.currentX = e.touches[0].clientX;
      }, { passive: true });

      this.sliderWrap.addEventListener('touchend', () => {
        if (!this.isDragging || !this.isMobile()) return;
        const diff = this.startX - this.currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
        this.isDragging = false;
      });
    }
  }

  document.querySelectorAll('.lbt-section').forEach((el) => new LBTSlider(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductTabs {
    constructor(el) {
      this.el = el;
      this.tabs = Array.from(el.querySelectorAll('[data-tab-target]'));
      this.panels = Array.from(el.querySelectorAll('.product-tabs__panel'));
      if (this.tabs.length === 0) return;
      this.bindEvents();
    }

    bindEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const targetId = tab.dataset.tabTarget;
          this.switchTab(tab, targetId);
        });
      });
    }

    switchTab(activeTab, targetId) {
      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === targetId;
        panel.classList.toggle('is-active', isActive);
        if (isActive) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }
  }

  document.querySelectorAll('.product-tabs').forEach((el) => new ProductTabs(el));

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-pt-add-form]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[data-pt-add-btn]');
    if (!btn || btn.disabled) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    const getCount = () => {
      const el = document.querySelector('.cart-bubble__text-count, [ref="cartBubbleCount"], [data-testid="cart-bubble"]');
      if (el) {
        const n = parseInt(el.textContent.trim(), 10);
        if (!isNaN(n)) return n;
      }
      return 0;
    };

    const setCount = (count) => {
      const selectors = ['.cart-bubble__text-count', '[ref="cartBubbleCount"]', '[data-testid="cart-bubble"]'];
      selectors.forEach((sel) => {
        document.querySelectorAll(sel).forEach((el) => {
          el.textContent = count;
          el.setAttribute('data-count', count);
        });
      });
      document.querySelectorAll('.cart-bubble').forEach((bubble) => {
        if (count > 0) {
          bubble.style.display = '';
          bubble.style.visibility = 'visible';
          bubble.style.opacity = '1';
        }
      });
      document.querySelectorAll('cart-icon').forEach((icon) => {
        if (count > 0) icon.classList.add('header-actions__cart-icon--has-cart');
      });
    };

    const oldCount = getCount();
    setCount(oldCount + 1);

    try {
      const formData = new FormData(form);
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      if (!response.ok) {
        setCount(oldCount);
        throw new Error('Add failed');
      }

      btn.textContent = 'Added';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1200);

      fetch(`${window.Shopify.routes.root}cart.js`)
        .then((r) => r.json())
        .then((cart) => setCount(cart.item_count))
        .catch(() => {});
    } catch (err) {
      console.error('[product-tabs] Add error:', err);
      btn.textContent = 'Try again';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  class ShopByCategory {
    constructor(el) {
      this.el = el;
      this.slider = el.querySelector('[data-sbc-slider]');
      this.track = el.querySelector('[data-sbc-track]');
      if (!this.track) return;

      this.items = Array.from(this.track.querySelectorAll('[data-sbc-item]'));
      this.prevBtn = el.querySelector('[data-sbc-prev]');
      this.nextBtn = el.querySelector('[data-sbc-next]');
      this.dotsWrap = el.querySelector('[data-sbc-dots]');

      this.total = this.items.length;
      if (this.total === 0) return;

      this.current = 0;
      this.autoplay = el.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;
      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;

      this.itemsPerView = this.getItemsPerView();
      this.maxIndex = Math.max(0, this.total - this.itemsPerView);

      this.buildDots();
      this.updateSlider();
      this.bindEvents();

      if (this.autoplay && this.total > this.itemsPerView) {
        this.startAutoplay();
      }
    }

    getItemsPerView() {
      const styles = getComputedStyle(this.el);
      const width = window.innerWidth;
      if (width <= 749) {
        return parseInt(styles.getPropertyValue('--sbc-items-mobile'), 10) || 3;
      } else if (width <= 1024) {
        return parseInt(styles.getPropertyValue('--sbc-items-tablet'), 10) || 4;
      }
      return parseInt(styles.getPropertyValue('--sbc-items-desktop'), 10) || 6;
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      const dotCount = this.maxIndex + 1;
      if (dotCount <= 1) {
        this.dotsWrap.style.display = 'none';
        return;
      }
      this.dotsWrap.style.display = '';
      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sbc-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          this.goTo(i);
          this.restartAutoplay();
        });
        this.dotsWrap.appendChild(dot);
      }
      this.dots = Array.from(this.dotsWrap.querySelectorAll('.sbc-dot'));
    }

    updateSlider() {
      const item = this.items[0];
      if (!item) return;
      const itemWidth = item.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.current * (itemWidth + gap));
      this.track.style.transform = `translateX(${offset}px)`;

      if (this.dots) {
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
      }

      if (this.prevBtn) this.prevBtn.disabled = this.current === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.current >= this.maxIndex;
    }

    goTo(index) {
      this.current = Math.max(0, Math.min(index, this.maxIndex));
      this.updateSlider();
    }

    next() {
      if (this.current >= this.maxIndex) {
        this.goTo(0);
      } else {
        this.goTo(this.current + 1);
      }
    }

    prev() {
      if (this.current <= 0) {
        this.goTo(this.maxIndex);
      } else {
        this.goTo(this.current - 1);
      }
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => { this.prev(); this.restartAutoplay(); });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => { this.next(); this.restartAutoplay(); });
      }

      this.slider.addEventListener('touchstart', (e) => this.onDragStart(e.touches[0].clientX), { passive: true });
      this.slider.addEventListener('touchmove',  (e) => this.onDragMove(e.touches[0].clientX),  { passive: true });
      this.slider.addEventListener('touchend',   () => this.onDragEnd());

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const newItemsPerView = this.getItemsPerView();
          if (newItemsPerView !== this.itemsPerView) {
            this.itemsPerView = newItemsPerView;
            this.maxIndex = Math.max(0, this.total - this.itemsPerView);
            this.current = Math.min(this.current, this.maxIndex);
            this.buildDots();
          }
          this.updateSlider();
        }, 150);
      });

      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay();
        else if (this.autoplay) this.startAutoplay();
      });
    }

    onDragStart(x) {
      this.isDragging = true;
      this.startX = x;
      this.currentX = x;
      this.stopAutoplay();
    }

    onDragMove(x) {
      if (!this.isDragging) return;
      this.currentX = x;
    }

    onDragEnd() {
      if (!this.isDragging) return;
      const diff = this.startX - this.currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.next();
        else this.prev();
      }
      this.isDragging = false;
      if (this.autoplay) this.startAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      if (this.total <= this.itemsPerView) return;
      this.timer = setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    restartAutoplay() {
      if (this.autoplay) { this.stopAutoplay(); this.startAutoplay(); }
    }
  }

  document.querySelectorAll('.sbc-section').forEach((el) => new ShopByCategory(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-us"] && !Shopify.designMode) return;
  try {
    
  class WCUSlider {
    constructor(el) {
      this.el = el;
      this.sliderWrap = el.querySelector('[data-wcu-slider]');
      this.track = el.querySelector('[data-wcu-track]');
      this.dotsWrap = el.querySelector('[data-wcu-dots]');
      if (!this.track) return;

      this.items = Array.from(this.track.querySelectorAll('[data-wcu-item]'));
      this.total = this.items.length;
      if (this.total === 0) return;

      this.current = 0;
      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;

      this.updateOnResize();
      window.addEventListener('resize', this.debounce(() => this.updateOnResize(), 150));
      this.bindTouch();
    }

    debounce(fn, delay) {
      let timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, delay);
      };
    }

    isMobile() {
      return window.innerWidth <= 749;
    }

    updateOnResize() {
      if (this.isMobile()) {
        this.setupSlider();
      } else {
        this.disableSlider();
      }
    }

    getItemsPerView() {
      const styles = getComputedStyle(this.el);
      return parseInt(styles.getPropertyValue('--wcu-items-mobile'), 10) || 1;
    }

    setupSlider() {
      this.itemsPerView = this.getItemsPerView();
      this.maxIndex = Math.max(0, this.total - this.itemsPerView);
      this.current = Math.min(this.current, this.maxIndex);
      this.buildDots();
      this.updateSlider();
    }

    disableSlider() {
      if (this.track) {
        this.track.style.transform = '';
      }
      if (this.dotsWrap) {
        this.dotsWrap.innerHTML = '';
      }
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      const dotCount = this.maxIndex + 1;
      if (dotCount <= 1) {
        this.dotsWrap.style.display = 'none';
        return;
      }
      this.dotsWrap.style.display = '';
      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wcu-dot' + (i === this.current ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsWrap.appendChild(dot);
      }
      this.dots = Array.from(this.dotsWrap.querySelectorAll('.wcu-dot'));
    }

    updateSlider() {
      if (!this.isMobile()) return;
      const item = this.items[0];
      if (!item) return;
      const itemWidth = item.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.current * (itemWidth + gap));
      this.track.style.transform = `translateX(${offset}px)`;

      if (this.dots) {
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
      }
    }

    goTo(index) {
      this.current = Math.max(0, Math.min(index, this.maxIndex));
      this.updateSlider();
    }

    next() {
      if (this.current >= this.maxIndex) this.goTo(0);
      else this.goTo(this.current + 1);
    }

    prev() {
      if (this.current <= 0) this.goTo(this.maxIndex);
      else this.goTo(this.current - 1);
    }

    bindTouch() {
      if (!this.sliderWrap) return;

      this.sliderWrap.addEventListener('touchstart', (e) => {
        if (!this.isMobile()) return;
        this.isDragging = true;
        this.startX = e.touches[0].clientX;
        this.currentX = this.startX;
      }, { passive: true });

      this.sliderWrap.addEventListener('touchmove', (e) => {
        if (!this.isDragging || !this.isMobile()) return;
        this.currentX = e.touches[0].clientX;
      }, { passive: true });

      this.sliderWrap.addEventListener('touchend', () => {
        if (!this.isDragging || !this.isMobile()) return;
        const diff = this.startX - this.currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
        this.isDragging = false;
      });
    }
  }

  document.querySelectorAll('.wcu-section').forEach((el) => new WCUSlider(el));

  } catch(e) { console.error(e); }
})();
})();
